<i *ngIf="sortBy === columnName" class="mdi" [ngClass]="{ 'mdi-arrow-down' : sortOrder == 'desc',  'mdi-arrow-up' : sortOrder == 'asc'}"></i>
